<template>
  <div class="help-page">
    <div class="container-inner">
      <div v-if="pending" class="page__columns-inner container-inner">
        <div class="page__main-col">
          <BasePreloader/>
        </div>
      </div>
      <div v-else class="help-page__columns">
        <main class="help-page__main-col">
          <div class="help-page__title">{{ $tHelp('Help') }}</div>
          <div class="help-page__tabs">
            <button v-for="(item, index) in help.categories"
                    :key="index"
                    @click="setTab(item.id)"
                    class="help-page__tab base-btn"
                    :class="{ _active: item.id === tab }">
              <span class="base-btn__text">{{ item.name }}</span>
            </button>
          </div>
          <div class="help-page__faq help-accordion">
            <HelpAccordion v-for="(item, index) in questionData"
                           :key="index">
              <div slot="title">{{ item.question }}</div>
              <div slot="content">
                <div v-html="item.answer"/>
              </div>
            </HelpAccordion>
          </div>
          <!-- <div class="help-page__button-row">
             <button type="button" class="base-btn base-btn&#45;&#45;outline-grey">
               <span class="base-btn__text">{{$tHelp('More information')}}</span>
             </button>
           </div>-->
        </main>


        <div class="help-page__side-col">
          <div class="help-page__side-title">{{ $tHelp('Questions?') }}</div>

          <div class="help-side _top">
            <div class="help-side__inner">
              <div class="help-side__title">{{ $tHelp('Useful connections') }}</div>
              <div class="socials  socials--contacts">
                <div class="socials__list">
                  <a v-for="(item, index) in messengers"
                     :key="index"
                     :href="item.link"
                     target="_blank"
                     class="socials__link">
                    <img :src="'https://api.jobian.com/storage/'+item.icon" alt="-">
                  </a>
                </div>
              </div>
              <span>{{ $tHelp('or') }}</span>
              <a :href="'mailto:'+adminEmail" class="base-btn base-btn--outline-grey base-btn--small">
                <span class="base-btn__text">{{ $tHelp('Write a letter') }}</span>
              </a>
            </div>
          </div>
          <div class="help-side _bottom">
            <!-- <div class="help-side__title">{{$tHelp('Ask a question in the chat')}}</div>
             <div class="help-side__icon _message-icon"></div>
             <button type="button" class="base-btn base-btn&#45;&#45;outline-grey base-btn&#45;&#45;small">
               <span class="base-btn__text">{{$tHelp('Open chat')}}</span>
             </button>
             <div class="help-side__divider"></div>-->
            <div class="help-side__title">{{ $tHelp('Hotline') }}</div>
            <div class="help-side__icon _phone-icon"></div>
            <div v-for="(phone, index) in adminPhones"
                 :key="phone + index">
              <a :href="phone | toLinkPhone"
                 class="help-side__tel">{{ phone }}</a>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
  import {http} from '../../axios'
  import HelpAccordion from "../../components/HelpAccordion";

  export default {
    name: "AccountHelpPage",
    components: {
      HelpAccordion,
    },
    data() {
      return {
        pending: false,
        help: {},
        tab: 0,
        contactVia: [],
        questionData: [],
        messengers: [],
        adminEmail: '',
        adminPhones: []
      }
    },
    computed: {},
    methods: {
      load() {
        this.pending = true
        return http.get('/api/cabinet/faq').then(({data}) => {
          this.help = data
        }).finally(() => {
          this.setTab(this.help.categories[0].id)
          this.pending = false
        })
      },
      setTab(i) {
        this.tab = i
        this.getQuestions(i)
      },
      getSocials() {
        this.pending = true
        http.get('/api/helper/footer-data').then(({data}) => {
          this.contactVia = data.data.contact_via
        })
      },
      getQuestions(id) {
        this.questionData = this.help.questions.filter(function (item) {
          return item.category_id === id
        })
      },
      getMessengers() {
        http.get('/api/cabinet/faq/messengers').then(({data}) => {
          this.messengers = data.data;
          this.adminEmail = data.admin_email;

          if (data.admin_phone) {
            this.adminPhones.push(data.admin_phone);
          }

          if (data.admin_phone2) {
            this.adminPhones.push(data.admin_phone2);
          }

          if (data.admin_phone3) {
            this.adminPhones.push(data.admin_phone3);
          }

        })
      }
    },
    created() {
      this.load()
      this.getSocials()
      this.getMessengers()
    }

  }
</script>

<style>

</style>
